// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import moment from 'moment';
//import { Sortable } from '@shopify/draggable';
//import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time
import Filter from './filter'
import Chart from 'chart.js/auto';
import Loading from '../Loading';
import Select from 'react-select';
import {ajaxPerso} from "../../../fnc.js"
import { mergeSelectStyles } from '../../../theme.js'
const refConst = require("../../../constants.js").v
//var moment = require('moment');

const styleList = mergeSelectStyles({
	menu: (provided) => ({
		...provided,
		zIndex: 99999,
	}),
	container: (provided) => ({
		...provided,
		width: "100%",
		minWidth: "100%"
	}),
	control: (provided, state) => ({
		...provided,
		minHeight: "42px",
		borderRadius: "5px",
		borderColor: state.isFocused ? "var(--eio-primary)" : "var(--eio-border)",
		boxShadow: state.isFocused ? "0 0 0 3px rgba(91, 163, 217, 0.2)" : "none",
		"&:hover": {
			borderColor: "var(--eio-primary)"
		}
	})
})

var initialState = {
	_isMounted: false
}

function Coverage(props){

	const [storeSelectedInChart, setStoreSelectedInChart] = useState(false);
	const [version, setVersion] = useState("0.9.0");
	const [loadingOn, setLoadingOn] = useState(true);
	const [chart, setChart] = useState(null);
	const [coverage, setCoverage] = useState(null);
	const [itemInStock, setItemInStock] = useState(false);

	const [selectedLabel, setSelectedLabel] = useState([]);
	const [storeIds, setStoreIds] = useState([]);
	const [labels, setLabels] = useState([]);
	const [valuesConsidered, setValuesConsidered] = useState([]);
	const [colors, setColors] = useState([]);
	const [selectedFromGraph, setSelectedFromGraph] = useState(null);
	const [selectedChartIndex, setSelectedChartIndex] = useState(null);
	
	const [groupActiveAndInactive, setGroupActiveAndInactive] = useState(true);
	const refSelectCountryNoIn = useRef(null);

	/* const [fromTo, setFromTo] = useState({
		from: new Date(moment().local().format('YYYY-MM-DD 00:00:00')),
		to: new Date(moment().local().format('YYYY-MM-DD 23:59:59'))
	}); */

	const [top, setTop] = useState(50);
	/* const [previousSearch, setPreviousSearch] = useState({
		"to": fromTo.to, 
		"from": fromTo.from,
		"top": top,
		"itemInStock": itemInStock
	}); */

	useEffect(() => {
		initialState._isMounted = true

		return () => initialState._isMounted = false
	}, [])
	
	useEffect(() => {
		loadCoverageFetching();
	}, [])

	/* useEffect(() => {
		if(previousSearch.top != top || previousSearch.to != fromTo.to || previousSearch.from != fromTo.from || previousSearch.itemInStock != itemInStock){
			if(fromTo.to && fromTo.from){
				loadCoverageFetching();
				setPreviousSearch({
					"to": fromTo.to, 
					"from": fromTo.from,
					"top": top,
					"itemInStock": itemInStock
				})
			}
		}
	}, [top, fromTo, itemInStock]) */

	useEffect(() => {
		console.log("coverage", coverage);
		
		if(document.querySelector("#ctnChartCoverageg") && coverage){

			let storeList = {}; // Make the script faster by just looking at this index instead of going through each sku over and over
			let sumCount = 0;
			let datasets = [];
			let joinedValue = {}

			console.info('labels', labels);
			console.info('valuesConsidered', valuesConsidered);
			console.info('colors', colors);

			valuesConsidered.forEach((value, i) => {
				datasets.push( value )
			})

			let selectedColors = get_chart_colors(colors, selectedChartIndex);
			let selectedBorders = get_chart_borders(colors, selectedChartIndex);
			let selectedOffsets = get_chart_offsets(colors, selectedChartIndex);

			if(!chart){
				
				setChart(new Chart(document.querySelector("#ctnChartCoverageg"), {
					type: 'pie',
					data: {
						"labels": labels,
						"datasets": [{
							data: datasets,
							backgroundColor: selectedColors,
							borderColor: selectedBorders,
							borderWidth: selectedChartIndex !== null ? 2 : 1,
							offset: selectedOffsets,
						}],
					},
					options: {
						aspectRatio: 2,
						plugins: {
							legend: {
								align: 'center',
								labels: {
									filter: filtersFnc
								}
							}
						},
						animation: {
							animateRotate : false
						},
						onClick: (a, b, c) => {
							if(b.length > 0){
								console.info('Click on position', b[0]);
								/* console.info('argument', a);
								console.info('labels', labels);
								console.info('valuesConsidered', valuesConsidered);
								console.info('colors', colors);
								console.info('b', b);
								console.info('argument', b[0]._chart.config.data.labels[b[0]._index]); */
								setSelectedChartIndex(b[0].index)
								setSelectedFromGraph(Object.assign({}, b[0])) // position
							}
						}
					}
				}))
			}else{
				//console.warn("Update chart");
				//chart.destroy()
				chart.data = {
					"labels": labels,
					"datasets": [{
						data: datasets,
						backgroundColor: selectedColors,
						borderColor: selectedBorders,
						borderWidth: selectedChartIndex !== null ? 2 : 1,
						offset: selectedOffsets,
					}]
				};
				chart.options.plugins.legend.filter = filtersFnc;
				chart.update();
				setChart(chart)
			}
		}
	}, [coverage, storeSelectedInChart, labels, valuesConsidered, colors, selectedChartIndex])

	useEffect(() => {
		/**
		 * Triggered when we click on a part of the PIE in the Graph
		 */
		console.info('selectedFromGraph', selectedFromGraph);
		if(selectedFromGraph)
			props.setSelectedStore(storeIds[selectedFromGraph.index])

		
	}, [selectedFromGraph])

	useEffect(() => {
		if(!props.selectedStore || !storeIds.length){
			setSelectedChartIndex(null)
			return;
		}

		let indexSelected = storeIds.findIndex(store => {
			return store.idStore === props.selectedStore.idStore && store.status === props.selectedStore.status
		})

		setSelectedChartIndex(indexSelected !== -1 ? indexSelected : null)
	}, [props.selectedStore, storeIds])

	useEffect(() => {
		if(coverage && props.stores){

			let valueConcidered = get_value_concidered()
			let labelList = [],
				valueList = [],
				colorsList = [],
				storeIdList = []

			// Split the result and create a few lists with the same index to have one line per store to show
			valueConcidered.values.forEach((obj, i) => {

				let idStore = valueConcidered.values[i].idStore
				let store = props.stores.find(o => {	if(o.id === idStore)	return o	})
				
				if(!groupActiveAndInactive)
					Object.keys(valueConcidered.values[i]).forEach(status => {
						if(['active', 'inactive'].indexOf(status) !== -1){
							colorsList.push(store? store.color : null)
							labelList.push( valueConcidered.labels[i] + " - " + status )
							valueList.push( valueConcidered.values[i][status] )
							storeIdList.push( {
								idStore: obj.idStore,
								status: status
							})
						}
					})
				else{
					storeIdList.push( {
						idStore: obj.idStore,
						status: null
					})
					colorsList.push(store? store.color : null)
					labelList.push( valueConcidered.labels[i] )
					valueList.push( valueConcidered.values[i].active + valueConcidered.values[i].inactive )
				}
			})

			// Filter from what is selectedf in the list.
			labelList.forEach((storeName, i) => {
				let listValueSelected = selectedLabel.map(o => {
					return o.value
				})

				if(listValueSelected.indexOf(storeName) !== -1){
					labelList.splice(i, 1)
					valueList.splice(i, 1)
					colorsList.splice(i, 1)
				}
			})
			
			console.info('VAL UPDATED');
			
			setColors(colorsList)
			setLabels(labelList)
			setStoreIds(storeIdList)
			setValuesConsidered(valueList)
		}
	}, [coverage, props.stores, groupActiveAndInactive, selectedLabel])

	let get_value_concidered = () => {
		let valueConcidered = [],
			labelsConcidered = []

		// ORganise the data received per store (active / inactive)
		Object.keys(coverage).slice(1).forEach(key => {
			let value = coverage[key]
			let nameInfo = key.split('_')
			let idStore = parseInt(nameInfo[0])
			let status = nameInfo[1]

			let objFound = valueConcidered.find(o => {
				if(o.idStore === idStore)	return o
			})
			
			if(!objFound){
				valueConcidered.push({
					idStore: idStore,
					active: 0,
					inactive: 0
				})
				objFound = valueConcidered[valueConcidered.length-1]
			}

			// Show only store not selected.
			objFound[status.toLowerCase()] = value;
		})

		valueConcidered.forEach(obj => {
			let store = props.stores.find(o => {
				if(o.id === obj.idStore)	return o
			})
				
			if(store){
				labelsConcidered.push(store.name)
			}
		})

		return {
			values: valueConcidered,
			labels: labelsConcidered
		}
	}

	let trigger_click_chart = () => {
		console.warn("labels", labels);
		console.warn("coverage", coverage);
	}

	let filtersFnc = (legend, chartData) => {
		if(labels.find(o => {
			//console.log(o.value + " === " + legend.text + " --- " + (o.value == legend.text));
			if(o.value == legend.text)
				return o
		}))
			return true
		return false
	}

	let get_chart_colors = (colorList, indexSelected) => {
		if(indexSelected === null || indexSelected === undefined) return colorList

		return colorList.map((color, i) => {
			return i === indexSelected ? "#f56600" : color
		})
	}

	let get_chart_borders = (colorList, indexSelected) => {
		return colorList.map((color, i) => {
			return i === indexSelected ? "#0f172a" : "#ffffff"
		})
	}

	let get_chart_offsets = (colorList, indexSelected) => {
		return colorList.map((color, i) => {
			return i === indexSelected ? 8 : 0
		})
	}

	const loadCoverageFetching = (args) => {
		setLoadingOn(true)
		fetchData(args, (r) => {
			if(!initialState._isMounted) return false
			console.info('Fetched Coverage', r);
			
			if(r){
				setCoverage(r)
			}else{
				console.warn(props);
				
				props.info({"error": r.error})
			}
			setLoadingOn(false)
		})
	}

	const fetchData = (args, callback) => {
		
		ajaxPerso( Object.assign({
			"trigger": "get_coverage_info",
			"api": "eio",
		}, args), callback, function(jqXHR, textStatus) {
			if(!initialState._isMounted) return false

			props.info({error: textStatus})
			console.warn( textStatus );
		});
	}

	return (
		<div className={(props.className? props.className : "") + " coverage-panel" + (!props.integrated? " coverage-panel--standalone" : "")}>
			<div className="coverage-panel-header">
				<div>
					<p className="coverage-panel-eyebrow">Marketplace coverage</p>
					<h3 className="coverage-panel-title">Store distribution</h3>
				</div>
				<span className="coverage-panel-version">v{version}</span>
			</div>

			<div className="coverage-panel-controls noselect">
				<div className="coverage-panel-field">
					<label>Hide stores from chart</label>
					<Select
						styles={styleList}
						onChange={(selectedOption) => {
							console.log(selectedOption);
							setSelectedLabel(selectedOption)
						}}
						options={(() => {
							return labels.map(label => {
								return {
									value: label,
									label: label
								}
							})
						})()}
						value={selectedLabel}
						defaultValue={selectedLabel}
						isSearchable={true}
						isMulti={true}
						placeholder={"All stores visible"}
					/>
				</div>

				<div className="coverage-panel-toggle-row">
					<div className="custom-control custom-switch coverage-panel-switch">
						<input type="checkbox" className="custom-control-input" id="customSwitch1" onChange={(val) => {
							setSelectedLabel([])
							setGroupActiveAndInactive($(val.target).is(':checked')? true : false)
						}} checked={groupActiveAndInactive}/>
						<label className="custom-control-label" htmlFor="customSwitch1">Group active and inactive</label>
					</div>
				</div>

				<div className="coverage-panel-store-filter">
					<div className="custom-control custom-switch coverage-panel-switch">
						<input type="checkbox" checked={props.toggleNotInShop()? true : false} className="custom-control-input" id="customSwitchNotInShop" onChange={(val) => {
							if(refSelectCountryNoIn.current.value.length === 0)
								props.info({error: "Please select a store in the list"})

							if(!val.target.checked)
								props.toggleNotInShop(false)
							else
								props.toggleNotInShop(refSelectCountryNoIn.current.value.length > 0? refSelectCountryNoIn.current.value : false)
						}}/>
						<label className="custom-control-label" htmlFor="customSwitchNotInShop">Only items not in store</label>
					</div>
					<select ref={refSelectCountryNoIn} className="form-control form-control-sm coverage-panel-store-select" onChange={(e) => {
						props.toggleNotInShop(e.target.value.length > 0? e.target.value : false)
					}}>
						<option value="">Select a store</option>
						{
							props.stores.filter(store => {
								if([
									refConst.id_store_hausfTools,
									refConst.id_store_eio,
									refConst.id_store_eBay_EIO,
									refConst.id_store_amazon_EIO,
									refConst.id_store_amazon_GOTT,
									refConst.id_store_walmart_eio
								].indexOf(store.id) !== -1)
									return store
							}).map(store => {
								return <option key={store.id} value={store.id}>{store.name}</option>
							})
						}
					</select>
				</div>
			</div>

			<div className="coverage-panel-chart">
				<canvas id="ctnChartCoverageg"></canvas>
			</div>

			<div className="coverage-panel-footer">
				<span>Finale item count</span>
				<strong>{props.vari.total_items}</strong>
			</div>
			<Loading loading={loadingOn} centered={true} />
		</div>

	);
}

export default Coverage;